/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { InputLabel } from "@mui/material";
import { styled } from "@mui/material/styles";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDateTimePicker } from "@mui/x-date-pickers";

import dayjs from "dayjs";
import FormControl from "@mui/material/FormControl";

const StyledFormControl = styled(FormControl, {
    shouldForwardProp: (prop) => !["label", "onClick", "value", "valueLabelFormat", "valueLabelDisplay"].includes(prop),
})(({
    theme, label, onClick, value, valueLabelFormat, valueLabelDisplay,
}) => ({

    "& .Mui-disabled fieldset": {
        backgroundColor: theme.palette.action.disabledBackground,
    },
    "& .Mui-disabled": {
        color: `${theme.palette.grey.primary} !important`,
        "-webkit-text-fill-color": "initial",
    },
    "& .MuiOutlinedInput-root": {
        background: "none",
        fontSize: 12,
        margin: 0,
        padding: 0,
        "& .Mui-disabled": {
            cursor: (onClick && value) && "pointer",
            color: (onClick && value) && "#4594AD",
            textDecoration: (onClick && value) && "underline",
            "&:hover": {
                color: (onClick && value) && "inherit",
            },
        },
        "& .MuiOutlinedInput-notchedOutline": {
            "&  legend": {
                border: "none",
            },
            top: 0,
            ...label ? {
                height: 24,
                marginTop: 12,
            } : {
                height: 24,
            },
        },
        "& .MuiOutlinedInput-input": {
            // paddingTop: 4,
            // paddingBottom: 2,
            paddingLeft: 4,
            // paddingRight: 3,
        },
        "& .MuiIconButton-root": {
            minWidth: 16,
            marginRight: 4,
        },
        ...label ? {
            marginTop: 2,
            "& .MuiSelect-iconOutlined": {
                marginTop: 7,
            },
            // "& .MuiOutlinedInput-input": {
            //     marginTop: 13,
            // },
        } : {
            "& .MuiSelect-iconOutlined": {
                marginTop: "1px!important",
            },
            "&>*:not(.MuiOutlinedInput-notchedOutline):not(.MuiSelect-select)": {
                marginTop: 2,
            },
            "& .MuiSelect-select": {
                marginTop: 0.75,
            },
        },
    },
    "& .MuiInputLabel-shrink": {
        fontSize: 12,
        transform: "translate(2px, -7px) scale(1) !important",
    },
    "& .MuiOutlinedInput-notchedOutline legend": {
        display: "none",
    },
    "& .MuiSelect-select": {
        paddingRight: "10px!important",
    },
    "& .MuiSelect-icon": {
        marginRight: -4,
    },
    ...label ? {
        marginTop: (valueLabelFormat || valueLabelDisplay === "on") && "15px",
    } : {
        height: 24,
    },
}));

function CustomDateTimePicker(props) {
    const {
        fullWidth,
        onChange,
        label,
        onClick,
        disabled,
        error,
        name,
        value,
        valueLabelDisplay = "auto",
        valueLabelFormat,
        required,
        maxDateTime,
        minDateTime,
        onError,
        inputProps,
    } = props;

    const [state, setState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: "selection",
        },
    ]);

    // const classes = useStyles();

    const onChangeHandler = (item) => {
        const selection = [item.selection];

        setState(selection);
        if (onChange) {
            onChange(selection);
        }
    };

    return (
        <StyledFormControl
            label={label}
            variant="outlined"
            required={required}
            fullWidth={fullWidth}
            // sx={sx}
            error={error}
        >
            {label ? (
                <InputLabel>
                    {label}
                </InputLabel>
            ) : null}
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DesktopDateTimePicker
                    disabled={disabled}
                    minutesStep={inputProps?.minutesStep || 15}
                    value={value ? dayjs(value) : null}
                    onError={onError}
                    name={name}
                    minDateTime={minDateTime && dayjs(minDateTime)}
                    maxDateTime={maxDateTime && dayjs(maxDateTime)}
                    onAccept={(e) => onChange(e)}
                    format="DD.MM.YYYY - HH:mm"
                    slotProps={{
                        textField: { placeholder: "tt.mm.jjjj - hh: mm" },
                        day: {
                            sx: { fontSize: "11px" },
                        },
                        field: {
                            onBlur: (e) => onChange(dayjs(e.target.value, "DD.MM.YYYY - hh:mm")),
                        },
                    }}
                    ampm={false}
                />
            </LocalizationProvider>
        </StyledFormControl>
    );
}

export default CustomDateTimePicker;
